import React from "react";
import AssetsOverview from "../../Components/Assets/AssetsOverview/AssetsOverview.component";

function AssetsPage(props) {
  return <AssetsOverview params={props.match.params} />;
}

export default AssetsPage;
